<p class="alert alert-danger" *ngIf="errorMessage">{{ errorMessage }}</p>
<form
  [formGroup]="providerForm"
  *ngIf="providerForm"
  autocomplete="off"
  (ngSubmit)="saveProvider($event)"
>
  <div class="row mb-3">
    <div class="form-group col-lg-4">
      <label>Name <span class="text-danger">*</span></label>
      <div class="input-group" style="width: 100%">
        <input
          type="text"
          formControlName="name"
          class="form-control"
          placeholder="Enter Name"
          style="width: 100%"
        />
      </div>
      <div class="alert alert-danger" *ngIf="formValidator.formErrors.name">
        {{ formValidator.formErrors.name }}
      </div>
    </div>
    <div [ngClass]="{ 'offset-lg-4': isCreate }" class="form-group col-lg-4">
      <label>Payment Method <span class="text-danger">*</span></label>
      <div class="input-group" style="width: 100%">
        <select
          formControlName="paymentOptionId"
          (change)="paymentOptionChange({ value: f.value })"
          class="form-control"
          #f
        >
          <option disabled value="null" selected>Choose Payment Method</option>
          <option *ngFor="let payment of payment_methods" [value]="payment.id">
            {{ payment.display_name }}
          </option>
        </select>
      </div>
      <div
        class="alert alert-danger"
        *ngIf="formValidator.formErrors.paymentOptionId"
      >
        {{ formValidator.formErrors.paymentOptionId }}
      </div>
    </div>
  </div>
  <div class="row groupInput">
    <h4>Fees</h4>
    <div class="form-group col-lg-4">
      <label>On US <span class="text-danger">*</span></label>
      <div class="input-group" style="width: 100%">
        <input
          type="number"
          formControlName="OnUSRate"
          class="form-control"
          placeholder="Enter On US Rate"
          style="width: 100%"
        />
      </div>
      <div class="alert alert-danger" *ngIf="formValidator.formErrors.OnUSRate">
        {{ formValidator.formErrors.OnUSRate }}
      </div>
    </div>

    <div class="form-group col-lg-4">
      <label>Off US <span class="text-danger">*</span></label>
      <div class="input-group" style="width: 100%">
        <input
          type="number"
          formControlName="OffUsRate"
          class="form-control"
          placeholder="Enter Off US Rate"
          style="width: 100%"
        />
      </div>
      <div
        class="alert alert-danger"
        *ngIf="formValidator.formErrors.OffUsRate"
      >
        {{ formValidator.formErrors.OffUsRate }}
      </div>
    </div>

    <div class="form-group col-lg-4">
      <label>Flat <span class="text-danger">*</span></label>
      <div class="input-group" style="width: 100%">
        <input
          type="number"
          formControlName="flatRate"
          class="form-control"
          placeholder="Enter Flat Rate"
          style="width: 100%"
        />
      </div>
      <div class="alert alert-danger" *ngIf="formValidator.formErrors.flatRate">
        {{ formValidator.formErrors.flatRate }}
      </div>
    </div>
  </div>
  <div
    class="row groupInput" *ngIf="payment_config.length > 0">
    <h4>Configration</h4>
    <div class="form-group col-lg-4" *ngFor="let config of payment_config; let configIndex = index;">
      <label>{{config.name}} <span class="text-danger">*</span></label>
      <div class="input-group" style="width: 100%">
        <input
          type="text"
          class="form-control"
          [placeholder]="config.name"
          [value]="config.value"
          (change)="config.value = $event.target.value"
          style="width: 100%"
        />
      </div>
    </div>
  </div>
  <button type="submit" class="btn btn-primary">Save Provider</button>
</form>
